import { Form } from './form';

export class RetrieveEmailForm extends Form {

    constructor(form, container, view) {
        super(form);
        this.container = container;
        this.view = view;
        this.addFormBehavior();    
    }

    addFormBehavior() {
		this.onSubmit();
		this.onKeyUp();
    }

    onSubmit() {
        let self = this;
        if (this.submitButton === null) {
            this.submitButton = this.form.querySelectorAll(".button-inline")[1];
        }
        
        this.submitButton.addEventListener('click', function(event) {
            let disabled = event.srcElement.classList.contains('disabled');
            if (!disabled) {
                // submit logic
                self.form.submit();
            }
        });
    }
	
	onKeyUp() {
        let self = this;
        if (this.submitButton === null) {
            this.submitButton = this.form.querySelectorAll(".button-inline")[1];
        }
		
        var inputs = this.form.querySelectorAll(".input");
		for (let i=0; i<inputs.length; i++) {
			inputs[i].addEventListener("keyup", e => {
				var allAreFilled = true;
				var allInputs = this.form.querySelectorAll(".input");
				for (let a=0; a<allInputs.length; a++) {
					if (allInputs[a].value.length == 0) {
						allAreFilled = false;
					}
				}
				if (allAreFilled) {
					self.submitButton.classList.remove("disabled");
				} else {
					self.submitButton.classList.add("disabled");
				}
			});
		}
	}
}
